import { render } from "./Prediction_of_cell_marker_variations.vue?vue&type=template&id=7649185e&scoped=true"
import script from "./Prediction_of_cell_marker_variations.vue?vue&type=script&lang=js"
export * from "./Prediction_of_cell_marker_variations.vue?vue&type=script&lang=js"

import "./Prediction_of_cell_marker_variations.vue?vue&type=style&index=0&id=7649185e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7649185e"]])

export default __exports__